import axios from 'axios';
import Vue from 'vue'

const service = axios.create({
	baseURL: 'http://api.advancedmaterials.org.cn', // 设置默认的请求根路径
	// baseURL: 'http://127.0.0.1:8081', // 设置默认的请求根路径
	timeout: 5000, // 设置请求超时时间
	headers: {
	    'Content-Type': 'application/json',
	},
});

service.interceptors.request.use(
	config => {
		// 在这里可以为请求添加自定义头部，比如 Token
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		}
		return config;
	},
	error => {
		// 处理请求错误
		// console.error('请求错误：', error);
		return Promise.reject(error);
	}
);

service.interceptors.response.use(
	response => {
		const res = response.data;
		// 根据接口文档，处理响应数据
		if (res.code !== 200) {
			// this.$message.error(res.message)
			// console.error('请求失败：', res.message);
			Vue.prototype.$toast({
				message: res.message,
				type: 'error',
			})
			return null;
			// Vue.prototype.$toast({
			//     message: res.message || 'Error',
			//     type: 'error',
			// })
		} else {
			return res;
		}
	},
	error => {
		// 处理响应错误
		Vue.prototype.$toast({
		    message: error.message,
		    type: 'error',
		})
		return Promise.reject(error);
	}
);

export default service;
